import React from "react";

const ArrowIcon = ({ width = 24, height = 25, color = "#E91515" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none">
      <path
        d="M14.4302 6.03125L20.5002 12.1013L14.4302 18.1712"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.5 12.1016H20.33"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ArrowIcon;
